// extracted by mini-css-extract-plugin
export default {"link":"mK-z","disabled":"nK-z"};